import React from 'react';
import cn from 'classnames';

import { formatPrice } from '../../../../utils/formatters';

import styles from './styles.module.scss';

const DeviceVariant = ({
  variant,
  clickHandle,
  isSubCancelled,
  deviceHaveUpcomingPlan,
}) => {
  const classes = !isSubCancelled
    ? {
        [styles.disabled]: variant.isDisabled,
        [styles.active]: variant.currentPlan,
        [styles.recommended]: variant.recommended,
        [styles.default]: variant.isDefault && !isSubCancelled,
        [styles.upcoming]: variant.upcomingPlan,
      }
    : {
        [styles.disabled]: true,
        [styles.subCancelled]: true,
      };
  const handleClick = () => {
    if (!isSubCancelled && !variant.upcomingPlan) {
      if (!variant.currentPlan || deviceHaveUpcomingPlan) {
        clickHandle(variant);
      }
    }
  };
  return (
    <li className={cn(styles.deviceVariant, classes)} onClick={handleClick}>
      <p className={styles.deviceVariantName}>{variant.planName}</p>
      <p className={styles.deviceVariantSize}>
        {variant?.amount?.replace('gb', '')}
        <span>GB</span>
      </p>
      <p className={styles.deviceVariantPrice}>
        {`$${formatPrice(variant.price)}`}
        <span>/month</span>
      </p>
    </li>
  );
};

export default DeviceVariant;
